declare namespace $ {

	type $yuf_number_range_string__type_yuf_number_range_1 = $mol_type_enforce<
		ReturnType< $yuf_number_range['type'] >
		,
		ReturnType< $yuf_number_range_string['type'] >
	>
	type $yuf_number_range_string__value_yuf_number_range_2 = $mol_type_enforce<
		ReturnType< $yuf_number_range['value_string'] >
		,
		ReturnType< $yuf_number_range_string['value'] >
	>
	type $yuf_number_range_string__hint_yuf_number_range_3 = $mol_type_enforce<
		ReturnType< $yuf_number_range['hint'] >
		,
		ReturnType< $yuf_number_range_string['hint'] >
	>
	type $yuf_number_range_string__enabled_yuf_number_range_4 = $mol_type_enforce<
		ReturnType< $yuf_number_range['string_enabled'] >
		,
		ReturnType< $yuf_number_range_string['enabled'] >
	>
	type $yuf_number_range_string__submit_yuf_number_range_5 = $mol_type_enforce<
		ReturnType< $yuf_number_range['submit'] >
		,
		ReturnType< $yuf_number_range_string['submit'] >
	>
	type $yuf_number_range_string__min_yuf_number_range_6 = $mol_type_enforce<
		ReturnType< $yuf_number_range['value_min'] >
		,
		ReturnType< $yuf_number_range_string['min'] >
	>
	type $yuf_number_range_string__max_yuf_number_range_7 = $mol_type_enforce<
		ReturnType< $yuf_number_range['value_max'] >
		,
		ReturnType< $yuf_number_range_string['max'] >
	>
	type $yuf_number_range_string__step_yuf_number_range_8 = $mol_type_enforce<
		ReturnType< $yuf_number_range['step'] >
		,
		ReturnType< $yuf_number_range_string['step'] >
	>
	export class $yuf_number_range extends $mol_number {
		type( ): string
		step( ): number
		dec_icon( ): $mol_icon_minus
		inc_icon( ): $mol_icon_plus
		String( ): $yuf_number_range_string
	}
	
}

//# sourceMappingURL=range.view.tree.d.ts.map